import { makeAutoObservable } from "mobx";
import { ContactDetailsStorageManager } from "../../storageManagers";
import { InvoiceDetailsStorageManager } from "../../storageManagers/InvoiceDetailsStorageManager";
import { Availability } from "../Availability";
import { Consents } from "../Consents";
import { ContactDetails } from "../ContactDetails";
/**
 * Represents the customer making the order.
 */
export class OrderReceiver {
    constructor(params) {
        this.invoiceRequest = params.invoiceRequest;
        this.contactDetails = params.contactDetails;
        this.consents = params.consents;
        makeAutoObservable(this);
    }
    static empty(params) {
        var _a;
        const contactDetailsStorageManager = new ContactDetailsStorageManager(params.validatePhoneService);
        const invoiceDetailsStorageManager = new InvoiceDetailsStorageManager();
        return new OrderReceiver({
            invoiceRequest: invoiceDetailsStorageManager.restore(),
            contactDetails: (_a = contactDetailsStorageManager.restore()) !== null && _a !== void 0 ? _a : ContactDetails.empty(params),
            consents: Consents.empty(),
        });
    }
    lockContactDetails(owner) {
        return this.contactDetails.lock(owner);
    }
    // paymentChannel
    get availability() {
        return Availability.composite([
            this.contactDetails.availability,
            this.consents.availability,
            this.invoiceRequest
                ? this.invoiceRequest.availability
                : Availability.available(),
        ]);
    }
    get checkoutData() {
        return {
            customer: {
                ...this.contactDetails.checkoutData,
                ...this.consents.checkoutData,
            },
            vatId: this.invoiceRequest ? this.invoiceRequest.vatId.toString() : null,
        };
    }
}
